import React, { FC } from 'react';
import { QuotePdfLink } from '../QuotePdfLink';
import styles from './styles.module.css';

type ScreenHeaderProps = {
  headerText: string;
  subHeaderText?: string;
  hideQuotePdfLink?: boolean;
};

export const ScreenHeader: FC<ScreenHeaderProps> = ({
  headerText,
  subHeaderText,
  hideQuotePdfLink = false,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <h2 className={styles.headerText}>{headerText}</h2>
        <div className={styles.subText}>{subHeaderText}</div>
      </div>
      {!hideQuotePdfLink && <QuotePdfLink />}
    </div>
  );
};
